export function fixEmissionPointProblem(options, companyUserStates) {
  const { hideDialogFn, router, toast, t } = options;

  if (hideDialogFn && typeof hideDialogFn === 'function') {
    hideDialogFn();
  }

  if (!companyUserStates) {
    return;
  }

  if (!companyUserStates.hasEmissionPoints) {
    router.push('/companysettings');
    setTimeout(() => {
      selectBranchesTab(toast, t);
    }, 500);
  } else {
    toast.add({
      severity: 'warn',
      detail: t('shared.selectEmissionPoint'),
      life: 3000,
    });
    
    const emissionPointSelector = document.querySelector('.emission-point-selector');
    const isSmallScreen = window.innerWidth <= 991;
    const topbarEndContainer = document.querySelector('.layout-topbar-end');
    const isMenuVisible = topbarEndContainer && window.getComputedStyle(topbarEndContainer).display !== 'none';

    if (isSmallScreen && !isMenuVisible) {
      const mobileMenuButton = document.querySelector('.layout-topbar-mobile-button');
      if (mobileMenuButton) {
        mobileMenuButton.click();
      }
    }

    if (emissionPointSelector) {
      emissionPointSelector.classList.add('emission-point-highlight');
      
      const selectBranch = document.querySelector('#selectBranch');
      if (selectBranch) {
        selectBranch.click();
      } else {
        emissionPointSelector.click();
      }
    }
  }
}

/**
 * @param toast - El servicio de toast para mostrar mensajes
 * @param t - La función de traducción
 */
function selectBranchesTab(toast, t) {
  const firstAttemptSuccessful = trySelectBranchesTab();

  if (firstAttemptSuccessful) {
    clickAddBranchButton(toast, t);
  } else {
    setTimeout(() => {
      const secondAttemptSuccessful = trySelectBranchesTab();
      if (secondAttemptSuccessful) {
        clickAddBranchButton(toast, t);
      }
    }, 1000);
  }
}

/**
 * @param toast - El servicio de toast para mostrar mensajes
 * @param t - La función de traducción
 */
function clickAddBranchButton(toast, t) {
  let addButton = document.querySelector('#addBranch');
  
  if (addButton) {
    addButton.click();
    showNoEmissionPointsToast(toast, t);
  } else {
    setTimeout(() => {
      addButton = document.querySelector('#addBranch');
      
      if (addButton) {
        addButton.click();
        showNoEmissionPointsToast(toast, t);
      }
    }, 500);
  }
}

/**
 * @param toast - El servicio de toast para mostrar mensajes
 * @param t - La función de traducción
 */
function showNoEmissionPointsToast(toast, t) {
  if (toast && t) {
    setTimeout(() => {
      toast.add({
        severity: 'warn',
        detail: t('shared.noEmissionPoints'),
        life: 4000,
      });
    }, 1000);
  }
}

/**
 * @returns boolean - Indica si se encontró y seleccionó correctamente la pestaña
 */
function trySelectBranchesTab() {
  const tabItems = document.querySelectorAll('.p-tabview-nav li');
  if (tabItems.length >= 2) {
    const branchesTab = tabItems[1];
    if (branchesTab) {
      const tabLink = branchesTab.querySelector('a');
      if (tabLink) {
        tabLink.click();
        return true;
      } else {
        branchesTab.click();
        return true;
      }
    }
  }
  
  return false;
}
